import { render } from "./PolicyActions.vue?vue&type=template&id=4fc522f2"
import script from "./PolicyActions.vue?vue&type=script&lang=js"
export * from "./PolicyActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__